// we may need to punt on this and move to render?
// reason being it's not technically SSR but...
// it's basically the saved output of react so might as well be
import { render } from "react-dom";

// all possible components lazy loaded
import components from "../components/lazyComponents.js"; //" /components/lazyComponents.js";
// parser that wraps each dom tree parsed in a <Suspense/> tag
// fallback is same HTML dangerously set as HTML
import htmlToJSX from "./htmlToJSX.jsx";

// All possible nodes to make interactive
let domNodes = document.querySelectorAll("[data-react]");
// algo to reduce nodes down to root nodes
// this is due to htmlToJSX recursively walking down
// node tree to render all comoponents
let rootNodes = [...domNodes].filter((node) => {
	let parent = node.parentElement;
	let next = parent?.closest("[data-react]");
	return !next;
});

// helper function to ensure the root nodes are
// not injected into but actually replaced
function renderReplace(reactComponent, element) {
	const targetNode = document.createElement("div");
	targetNode.innerHTML = element.outerHTML;
	// hydrate(reactComponent, element);
	// render(reactComponent, element);

	// Due to lazy loading components we have to wait for the dom to be ready

	render(reactComponent, targetNode, () => {
		// Due to lazy loading components we need to wait for the dom to be ready
		// before asking the element to be replaced with our targetNode's child.
		// Here we assume the first mutation observed React as attached itself
		// so we should be able to safely replace the server rendered DOM Node with React's
		const observer = new MutationObserver((_, observer) => {
			element.replaceWith(targetNode.childNodes[0]);
			observer.disconnect();
		});
		observer.observe(targetNode, {
			attributes: true,
			childList: true,
			subtree: true,
		});
		// TODO: make this smarter on handling if component wasn't lazy loaded instead of a static timing
		setTimeout(() => {
			observer.disconnect();
			element.replaceWith(targetNode.childNodes[0]);
		}, 750);
	});
}

// now we just loop through nodes and make them reactive
rootNodes.forEach((node) => {
	let html = node.outerHTML;
	renderReplace(htmlToJSX(components, html), node);
});

// debug
// console.log("root nodes", rootNodes);
